import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('./views/MainLayout.vue'),
      children: [
        {
          path: '',
          redirect: { name: 'login' },
          meta: {
            requiresVisitor: true,
          },
        },
        {
          path: 'history',
          component: () => import('./views/History/Main.vue'),
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: '',
              name: 'history',
              component: () => import('./views/History/History.vue'),
            },
            {
              path: 'animal-adding',
              name: 'history-animal-adding',
              props: true,
              component: () =>
                import('./views/History/HistoryAnimalAdding.vue'),
            },
            {
              path: 'customer-adding',
              name: 'history-customer-adding',
              component: () =>
                import('./views/History/HistoryCustomerAdding.vue'),
            },
            {
              path: 'order',
              name: 'history-order',
              component: () => import('./views/History/Order.vue'),
            },
          ],
        },
        {
          path: 'receive',
          component: () => import('./views/Receive/Main.vue'),
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: '',
              name: 'receive',
              props: true,
              component: () => import('./views/Receive/Receive.vue'),
            },
            {
              path: 'detail',
              name: 'receive-detail',
              props: true,
              component: () => import('./views/Receive/ReceiveDetail.vue'),
              meta: {
                receiveAuth: true,
              },
            },
          ],
        },
        {
          path: 'result',
          component: () => import('./views/Result/Main.vue'),
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: '',
              name: 'result',
              component: () => import('./views/Result/Result.vue'),
            },
            {
              path: 'detail',
              name: 'result-detail',
              component: () => import('./views/Result/ResultDetail.vue'),
              meta: {
                resultAuth: true,
              },
            },
          ],
        },

        {
          path: 'report',
          name: 'report',
          component: () => import('./views/Report/Report.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'account',
          component: () => import('./views/Account/MainComponent.vue'),
          props: true,
          children: [
            {
              path: '',
              name: 'account',
              props: true,
              component: () => import('./views/Account/Main.vue'),
              meta: {
                requiresAuth: true,
                accountantAuth: true,
              },
            },
            {
              path: 'add-document',
              name: 'account-add-document',
              props: true,
              component: () => import('./views/Account/AddDocument.vue'),
              meta: {
                requiresAuth: true,
                addAccountantAuth: true,
              },
            },
            {
              path: 'document',
              name: 'document',
              props: true,
              component: () => import('./views/Account/DocumentView.vue'),
              meta: {
                requiresAuth: true,
                addAccountantAuth: true,
              },
            },
          ],
        },
        {
          path: 'account/document-detail',
          name: 'account-document-detail',
          component: () => import('./views/Account/DocumentDetail.vue'),
          meta: {
            requiresAuth: true,
            editAccountantAuth: true,
          },
        },
        {
          path: 'quality-control',
          component: () => import('./views/QualityControl/Main.vue'),
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: '',
              name: 'quality-control',
              component: () =>
                import('./views/QualityControl/QualityControl.vue'),
            },
          ],
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import('./views/Settings/Main.vue'),
          meta: {
            requiresAuth: true,
            settingsAuth: true,
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: {
        requiresVisitor: true,
      },
    },
    {
      path: '/mock-print',
      name: 'mockprint',
      component: () => import('./components/Print/PrintComponent.vue'),
    },
    {
      path: '/graphStat',
      name: 'graphStat',
      props: true,
      component: () => import('./components/Account/StatGraphComponent.vue'),
    },
  ],
});
